import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { AuthService } from '../services/auth/auth.service';
import { GoogleService } from '../services/auth/google/google.service';
import { UserInfoService } from 'src/app/shared/services/UserInfoService/user-info.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
})
export class LoginComponent {
  showPassword = false;
  submitted = false;
  googleIcon = './assets/' + environment.projectName + '/icons/google.svg';
  logo = './assets/' + environment.projectName + '/media/header/logo.png';
  lang: string = '';
  returnUrl: string = '/';
  user: any = { phone: '', sub: '' };  

  constructor(
    private google: GoogleService,
    private authService: AuthService,
    private userInfoService: UserInfoService,
    private route: ActivatedRoute,
    private router: Router,
  ) {
    this.route.params.subscribe((params) => {
      if (params) {
        this.lang = params['lang'];
        if (this.lang !== 'ar') {
          this.router.navigate(['/ar/login'], { queryParamsHandling: 'preserve' });
          return;
        }
      }
    });

    this.route.queryParams.subscribe((params) => {
      this.returnUrl = params['returnUrl'] || `/${this.lang}/home`;
    });
  }

  toggleShowPassword() { this.showPassword = !this.showPassword; }

  loginAsUser() {
    this.submitted = true;
    if (!this.user.phone || !this.user.sub) return;

    this.authService.loginAsUser(this.user).subscribe({
      next: (response: any) => {
        this.userInfoService.setUserInfo(response);
        this.router.navigateByUrl(this.returnUrl);
      },
      error: (err) => {
        const errorMessage = err?.error?.message || 'يوجد خطأ في تسجيل الدخول';
        Swal.fire({
          icon: 'error',
          title: 'خطأ',
          text: errorMessage,
          confirmButtonText: 'حسناً',
          confirmButtonColor: '#d33',
          customClass: { popup: 'swal-rtl' },
        });
      },
    });
  }

  loginWithGoogle() { this.google.login(); }
}